<template>
  <transition name="layout-fade" mode="out-in">
    <component :is="currentLayout" :key="currentLayout.name" class="min-h-screen" />
  </transition>
  <Toaster position="top-right" rich-colors />
</template>

<script>
import axios from 'axios'
import router from '@/router'
import { toast } from 'vue-sonner'
import { mapActions } from 'pinia'
import { useAuthStore } from '@/stores/auth.js'
import { Toaster } from '@/components/ui/sonner'
import Authenticated from '@/layouts/Authenticated.vue'
import Guest from '@/layouts/Guest.vue'

const emailVerificationMessagePattern = /verify your email|email address is not verified|email not verified|must verify.*email/i

export default {
  components: { Authenticated, Guest, Toaster },
  computed:{
    currentLayout() {
      return this.$route.meta.layout || 'Guest'
    }
  },
  mounted() {
    axios.interceptors.response.use((response) => {
      return response;
    }, (error) => {
      if (!error.response) {
        return Promise.reject(error);
      }

      const errorMessage = typeof error.response.data?.message === 'string'
        ? error.response.data.message.trim()
        : ''

      console.error(error)
      if (error.response.status === 401 || error.response.status === 419) {
        if (error.response.data.message === 'CSRF token mismatch.') return

        if (error.response.status === 401 && error.config.url === '/logout') {
          router.replace({ name: 'Login' })
          return
        }

        this.logout()
          .catch((error) => { console.error(error) })

        router.replace({ name: 'Login' })
      } else if (error.response.status === 403) {
        if (emailVerificationMessagePattern.test(errorMessage) && router.currentRoute.value.name !== 'VerifyEmail') {
          router.push({ name: 'VerifyEmail' })
        } else {
          toast.error(errorMessage || 'You are not allowed to perform this action.')
        }
      } else if (error.response.status === 423) {
        router.push({ name: 'ConfirmPassword' })
      }
      return Promise.reject(error);
    });
  },
  methods: {
    ...mapActions(useAuthStore, ['logout']),
  }
}
</script>
